import { useCallback, useContext, useEffect, useRef } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

interface Transition {
	retry: () => void;
}

interface BlockingNavigator {
	block?: (blocker: (transition: Transition) => void) => () => void;
}

export function useLeaveGuard(when: boolean, message: string): () => void {
	const { navigator } = useContext(UNSAFE_NavigationContext);
	const bypass = useRef(false);

	useEffect(() => {
		const history = navigator as unknown as BlockingNavigator;
		if (!when || typeof history.block !== 'function') {
			return;
		}
		const unblock = history.block(transition => {
			if (bypass.current || window.confirm(message)) {
				unblock();
				transition.retry();
			}
		});
		return unblock;
	}, [navigator, when, message]);

	return useCallback(() => {
		bypass.current = true;
	}, []);
}
